module.exports = __webpack_public_path__ + "img/inspirator.51a3fc97.svg";